// Types
import type { OutwriteShadesBrandColor } from '@outwrite/themes'

// External
import styled from '@emotion/styled'

// Other imports
import { flexContainerSpacingCss, Title as OriginalSectionTitle } from './Section'

import { MOBILE_WIDTH_PX } from '../constants'
import { TITLES } from '../font'

interface ColoredFlexSectionProps { bgColor: keyof OutwriteShadesBrandColor }
export const AltFlexSectionEven = styled.div<ColoredFlexSectionProps>`
  ${flexContainerSpacingCss}
  display: flex;
  flex-direction: row-reverse;
  justify-content: center;
  align-items: center;
  padding: 16px 36px 16px 64px;

  background-image: linear-gradient(
    to right,
    ${(props): string => props.theme.outwrite.colors[props.bgColor][200]} 0%,
    ${(props): string => props.theme.outwrite.colors[props.bgColor][200]} 66%,
    transparent 66%,
    transparent 100%
  );

  @media screen and (max-width: ${MOBILE_WIDTH_PX}px) {
    padding-left: 36px;
    flex-direction: column;
    background-image: linear-gradient(
      to top,
      ${(props): string => props.theme.outwrite.colors[props.bgColor][200]} 0%,
      ${(props): string => props.theme.outwrite.colors[props.bgColor][200]} 77%,
      transparent 77%,
      transparent 100%
    );
  }
`

export const AltFlexSectionOdd = styled.div<ColoredFlexSectionProps>`
  ${flexContainerSpacingCss}
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 36px;

  background-image: linear-gradient(
    to left,
    ${(props): string => props.theme.outwrite.colors[props.bgColor][200]} 0%,
    ${(props): string => props.theme.outwrite.colors[props.bgColor][200]} 66%,
    transparent 66%,
    transparent 100%
  );

  @media screen and (max-width: ${MOBILE_WIDTH_PX}px) {
    flex-direction: column;
    background-image: linear-gradient(
      to top,
      ${(props): string => props.theme.outwrite.colors[props.bgColor][200]} 0%,
      ${(props): string => props.theme.outwrite.colors[props.bgColor][200]} 77%,
      transparent 77%,
      transparent 100%
    );
  }
`

export const Title = styled(OriginalSectionTitle)`
  ${TITLES[900]}
  @media screen and (max-width: ${MOBILE_WIDTH_PX}px) {
    ${TITLES[700]}
  }
`
